// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gJHwu","col":"styles_col__3n7xT"};